import { PropTypes } from 'prop-types';
import React, { useCallback, useState } from 'react';

import { CRTrackerContext } from './cr-tracker-context';

export const CRTrackerProvider = ({ children }) => {
  const [selectedContract, setSelectedContract] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const handleSiteExpand = useCallback((contract) => {
    setSelectedEvent(null);
    setSelectedContract(contract);
  }, []);

  const provider = {
    selectedEvent,
    selectedContract,
    setSelectedEvent,
    setSelectedContract,
    handleSiteExpand,
  };

  return <CRTrackerContext.Provider value={provider}>{children}</CRTrackerContext.Provider>;
};

CRTrackerProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
